import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index.js'
// import axios from '../api/vue-axios/axios'

// import Login from '@/components/Login'
// import Signup from '@/components/Signup'
// import Waitlist from '@/components/Waitlist'
// import UserHome from '@/components/UserHome'
// import LandingPage from '@/components/LandingPage'
import ShutDownPage from '@/components/ShutDownPage'
// import PageNotFound from '@/components/PageNotFound'
// import LearnMore from '@/components/public/LearnMore'
// import PublicScripts from '@/components/public/PublicScripts'
// import AddProductLinkToScripts from '@/components/AddProductLinkToScripts'
// import Help from '@/components/Help'
// import Terms from '@/components/Terms'
// import Analytics from '@/components/Analytics'
// import Search from '@/components/search/Search'
// import MasterSearch from '@/components/search/MasterSearch'
// import MasterSearchPros from '@/components/search/MasterSearchPros'
// import MasterSearchScripts from '@/components/search/MasterSearchScripts'
// import NetworkRetailer from '@/components/network-retailer/NetworkRetailer'
//
// import ForgotPassword from '@/components/password/ForgotPassword'
// import ResetPassword from '@/components/password/ResetPassword'
//
// import Script from '@/components/Script'
// import addScriptProductLinks from '@/components/script/addScriptProductLinks'
// import EditScript from '@/components/script/EditScript'
// import NewScript from '@/components/script/NewScript'
//
// import ShareScript from '@/components/ShareScript'
// import ShareScriptEmail from '@/components/share/ShareScriptEmail'
// import ShareScriptSms from '@/components/share/ShareScriptSms'
// import ShareScriptUrl from '@/components/share/ShareScriptUrl'
//
// import UserProfile from '@/components/user/Profile'
// import UserSettings from '@/components/user/Settings'
// import Refer from '@/components/user/Refer'
// import CompleteApplication from '@/components/user/CompleteApplication'
//
// import ProProfile from '@/components/pro/ProProfile'
// import ProScripts from '@/components/pro/ProScripts'
// import ProScript from '@/components/pro/ProScript'

Vue.use(Router)

const router = new Router({
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'ShutDownPage',
      component: ShutDownPage
    },
    { path: '*', component: ShutDownPage }
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component: Login,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/signup',
    //   name: 'Signup',
    //   component: Signup,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/waitlist',
    //   name: 'Waitlist',
    //   component: Waitlist,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/forgot-password',
    //   name: 'ForgotPassword',
    //   component: ForgotPassword,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/complete-application',
    //   name: 'CompleteApplication',
    //   component: CompleteApplication,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/reset-password',
    //   name: 'ResetPassword',
    //   component: ResetPassword,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/learn-more',
    //   name: 'LearnMore',
    //   component: LearnMore,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/pro-scripts',
    //   name: 'PublicScripts',
    //   component: PublicScripts,
    //   meta: {
    //     blockedForUsers: true
    //   }
    // },
    // {
    //   path: '/master-search',
    //   name: 'MasterSearch',
    //   component: MasterSearch,
    //   children: [
    //     {
    //       path: 'pros',
    //       name: 'MasterSearchPros',
    //       component: MasterSearchPros
    //     },
    //     {
    //       path: 'scripts',
    //       name: 'MasterSearchScripts',
    //       component: MasterSearchScripts
    //     }
    //   ]
    // },
    // {
    //   path: '/terms',
    //   name: 'Terms',
    //   component: Terms
    // },
    // {
    //   path: '/home',
    //   name: 'Home',
    //   component: UserHome,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/search',
    //   name: 'Search',
    //   component: Search,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/new-script',
    //   name: 'NewScript',
    //   component: NewScript,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/user-profile',
    //   name: 'UserProfile',
    //   component: UserProfile,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/user-settings',
    //   name: 'UserSettings',
    //   component: UserSettings,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/refer',
    //   name: 'Refer',
    //   component: Refer,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/help',
    //   name: 'Help',
    //   component: Help,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/analytics',
    //   name: 'Analytics',
    //   component: Analytics,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/network-retailers/:retailer_id',
    //   name: 'NetworkRetailer',
    //   component: NetworkRetailer,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/scripts/:script_id',
    //   name: 'Script',
    //   component: Script,
    //   meta: {
    //     requiresAuth: true
    //   },
    //   children: [
    //     // {
    //     //   path: 'add',
    //     //   name: 'addScriptProductLinks',
    //     //   component: addScriptProductLinks
    //     // },
    //     {
    //       path: 'edit',
    //       name: 'EditScript',
    //       component: EditScript
    //     },
    //     {
    //       path: 'share',
    //       name: 'ShareScript',
    //       component: ShareScript,
    //       children: [
    //         {
    //           path: 'email',
    //           name: 'ShareScriptEmail',
    //           component: ShareScriptEmail
    //         },
    //         {
    //           path: 'sms',
    //           name: 'ShareScriptSms',
    //           component: ShareScriptSms
    //         },
    //         {
    //           path: 'url',
    //           name: 'ShareScriptUrl',
    //           component: ShareScriptUrl
    //         }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   path: '/scripts/:script_id/add',
    //   name: 'addScriptProductLinks',
    //   component: addScriptProductLinks,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/product-links/:product_link_id/add-to-scripts',
    //   name: 'AddProductLinkToScripts',
    //   component: AddProductLinkToScripts,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/404',
    //   name: 'PageNotFound',
    //   component: PageNotFound
    // },
    // // I believe that this must always be the last route defined, as we want other /root routes to take precedence over this one.
    // {
    //   path: '/:identifier',
    //   component: ProProfile,
    //   beforeEnter: (to, from, next) => {
    //     let identifier = to.params.identifier
    //     axios.get('/users/' + identifier + '/profile').then((response) => {
    //       store.dispatch('setPublicPro', response.data.user).then(() => {
    //         next()
    //       })
    //     }).catch((res) => {
    //       if (res.response.status === 404) {
    //         next({ path: '/404' })
    //       }
    //     })
    //     // window.Intercom('shutdown')
    //   },
    //   children: [
    //     {
    //       path: '',
    //       name: 'ProScripts',
    //       component: ProScripts
    //     },
    //     {
    //       path: 'scripts/:scriptId',
    //       name: 'ProScript',
    //       component: ProScript
    //     }
    //   ]
    // }
  ]
})



router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.blockedForUsers) && (store.getters.currentUser || localStorage.token)) {
    // Route is off-limits to logged-in users
    // Return them to homne page
    let path = '/home'

    return next({
      path: path
    })
  }

  if (!to.matched.some(record => record.meta.requiresAuth)) {
    // route is open to unauthenticated users
    return next()
  }

  // User token exists but currentUser has not been set (aka hard load on app)
  // We need to set current user and then go on our way
  if (localStorage.token && !store.getters.currentUser) {
    store.dispatch('setCurrentUser').then((user) => {
      store.dispatch('getNetworkRetailers').then(() => {
        next()
      })
    }).catch(() => {
      // If there's an error retrieving/setting the user, redirect to login
      // #setCurrentUser will handle setting the currentUser to null :)
      delete localStorage.token
      router.push({name: 'Login'})
    })
  } else {
    // trying to access a route that requires auth. Make sure we have a user. If not, throw up redirect
    if (store.getters.currentUser) next()
    else next('/login?redirect=' + to.path)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js